'use strict';

export const ERROR_400 = 'default.save.validation.message';
export const ERROR_500 = 'server.default.error.message';

export function getDeleteErrorMessage(status) {
  switch (status) {
    case 401:
      return 'delete.permission.denied.message';

    case 500:
    default:
      return ERROR_500;
  }
}

/**
 * @param {Object} props
 * @param {Array<String>} messageProps
 * @returns {*}
 */
export function getMessagesFromProps(props, messageProps) {
  const output = {};
  let i = messageProps.length;
  let key;

  while (i--) {
    key = messageProps[i];
    output[key] = props[key];
  }

  return output;
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-i18n/utils.js